import { useState, useEffect, useRef } from 'react'
import { createClient } from '@supabase/supabase-js'
import { AnalyticsEvent } from '../../shared/analytics/AnalyticsEvent';
import { useNavigate } from 'react-router-dom';
import CoorayFooter from '../../shared/components/footer/CoorayFooter';
import { useGoogleLogin } from '@react-oauth/google';
import { sendPageView } from '../../shared/utils/AnalyticsUtils';
import UserRepository from '../../repository/UserRepository';

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function LoginPage( { analytics } ) {

  const [session, setSession] = useState(null)
  const [isLoggingIn, setIsLoggingIn] = useState(false)
  const navigate = useNavigate()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [toastMessage, setToastMessage] = useState(null)

  useEffect(() => {
    if (toastMessage) {
        setTimeout(() => {
            setToastMessage(null)
        }, 3000)
    }
}, [toastMessage])

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      if (session) {
        checkSignUpStatusAndNavigate()
      }
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
      if (session) {
        checkSignUpStatusAndNavigate()
      }
    })

    sendPageView(analytics, AnalyticsEvent.LOGIN_VIEW, {})

    return () => {
      subscription.unsubscribe()
      // clearTimeout(currentTimeout)
    }
  }, [])

  const login = useGoogleLogin({
    onSuccess: tokenResponse => {
      console.log('Token response:', tokenResponse);
    },
    onError: error => {
      console.error('Login Failed:', error);
    },
    flow: 'auth-code',
    redirect_uri: `${window.location.protocol + "//" + window.location.host}/login/redirect`,
    ux_mode: 'redirect',
  });

  async function loginWithEmailAndPassword() {
    setIsLoggingIn(true)
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password
    })
    console.log(`sign in error ${error}`)
    if (error) {
      setToastMessage("❌ Invalid email or password")
      setIsLoggingIn(false)
      return
    } else {
      checkSignUpStatusAndNavigate()
    }
    console.log(`sign in data ${JSON.stringify(data)}`)
  }

  async function checkSignUpStatusAndNavigate() {
    const userRepository = new UserRepository()
    try {
      await userRepository.getUserProfile()
    } catch(e) {
      console.log(`get user profile error ${e.response.status}`)
      if (e.response.status == 404) {
        navigate("/profile/complete", {replace: true})
      } else {
        navigate("/login", {replace: true})
      }
      return
    }
    navigate("/dashboard", {replace: true})
  }

  function onEmailInputChange(event) {
      setEmail(event.target.value)
  }

  function onPasswordInputChange(event) {
    setPassword(event.target.value)
  }


  if (!session) {
    return (
      <div className='h-full flex flex-col'>
        <div className="navbar bg-base-200 px-4 shrink-0">
            <div className="flex-1">
                <a href="/">
                <img className="h-12" src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/zipmap-resources/full-logo-lightning-light.png"/>
                </a>
                <div className="text-xl font-bold px-2"></div>
            </div>
        </div>
        <div className="hero bg-base-200 overflow-x-hidden flex-1">
          <div className="hero-content max-w-5xl text-left grid grid-cols-1 gap-4 h-full">
            <div className='flex flex-col items-center w-[400px] max-w-[100%]'>
              <p className="text-lg text-center md:text-left pb-4">Hi 👋🏼! Please login to continue</p>
              
              <div className="font-bold text-base pt-2 pb-2 flex items-center w-full">
                  <span>Email</span>
              </div>
              <div className="flex w-full gap-2">
                  <div className="form-control flex-1 relative flex flex-row items-center gap-2">
                      <input className={`input input-bordered flex-1 rounded-md z-1`} value={email} placeholder={"Enter email here ..."} type="email" onChange={onEmailInputChange} />
                  </div>
              </div>

              <div className="font-bold text-base pt-2 pb-2 flex items-center w-full">
                  <span>Password</span>
              </div>
              <div className="flex w-full gap-2 pb-4">
                  <div className="form-control flex-1 relative flex flex-row items-center gap-2">
                      <input className={`input input-bordered flex-1 rounded-md z-1`} value={password} placeholder={"Your password ..."} type="password" onChange={onPasswordInputChange} />
                  </div>
              </div>

              {
                isLoggingIn &&
                  <div className='w-full flex flex-row items-center justify-center gap-2 py-4'>
                    <div className="loading loading-infinity loading-md"></div>
                    <div className='font-normal text-base-content'>Logging in ...</div>
                  </div>
              }

              <button className="btn h-auto btn-primary normal-case w-full" onClick={() => {
                          loginWithEmailAndPassword()
                    } }>
                      <div className='flex items-center gap-x-2 justify-between w-full'>
                      <svg className='w-6 h-6' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path className='fill-primary-content' d="M16.8 2H14.2C11 2 9 4 9 7.2V11.25H13.44L11.37 9.18C11.22 9.03 11.15 8.84 11.15 8.65C11.15 8.46 11.22 8.27 11.37 8.12C11.66 7.83 12.14 7.83 12.43 8.12L15.78 11.47C16.07 11.76 16.07 12.24 15.78 12.53L12.43 15.88C12.14 16.17 11.66 16.17 11.37 15.88C11.08 15.59 11.08 15.11 11.37 14.82L13.44 12.75H9V16.8C9 20 11 22 14.2 22H16.79C19.99 22 21.99 20 21.99 16.8V7.2C22 4 20 2 16.8 2Z" />
                      <path className="fill-primary-content" d="M2.75 11.25C2.34 11.25 2 11.59 2 12C2 12.41 2.34 12.75 2.75 12.75H9V11.25H2.75Z"/>
                      </svg>
                        <span className='grow text-primary-content'>Login</span>
                      </div>
                      
                </button>

                {/* <div className='pt-4 w-full text-center'>
                  <div className='text-base'><a className='text-primary' href="/reset-password">Forgot password?</a></div>
                </div> */}

                <div className='pt-4 w-full text-center'>
                  <div className='text-base'>or</div>
                </div>

                <div className='pt-4 w-full'>
                  <button className="btn h-auto btn-neutral normal-case w-full" onClick={() => {
                            login()
                      } }>
                        <div className='flex items-center gap-x-2 justify-between w-full'>
                        <svg className='w-6 h-6' viewBox="0 0 32 32" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><path d="M23.75,16A7.7446,7.7446,0,0,1,8.7177,18.6259L4.2849,22.1721A13.244,13.244,0,0,0,29.25,16" fill="#00ac47"/><path d="M23.75,16a7.7387,7.7387,0,0,1-3.2516,6.2987l4.3824,3.5059A13.2042,13.2042,0,0,0,29.25,16" fill="#4285f4"/><path d="M8.25,16a7.698,7.698,0,0,1,.4677-2.6259L4.2849,9.8279a13.177,13.177,0,0,0,0,12.3442l4.4328-3.5462A7.698,7.698,0,0,1,8.25,16Z" fill="#ffba00"/><polygon fill="#2ab2db" points="8.718 13.374 8.718 13.374 8.718 13.374 8.718 13.374"/><path d="M16,8.25a7.699,7.699,0,0,1,4.558,1.4958l4.06-3.7893A13.2152,13.2152,0,0,0,4.2849,9.8279l4.4328,3.5462A7.756,7.756,0,0,1,16,8.25Z" fill="#ea4435"/><polygon fill="#2ab2db" points="8.718 18.626 8.718 18.626 8.718 18.626 8.718 18.626"/><path d="M29.25,15v1L27,19.5H16.5V14H28.25A1,1,0,0,1,29.25,15Z" fill="#4285f4"/></svg>
                          <span className='grow text-neutral-content'>Sign In with Google</span>
                        </div>
                    </button>
                </div>
                <div className='pt-4 w-full text-center'>
                  <div className='text-base'>Don't have an account? <a className='font-bold underline text-primary' href="/register">Sign up</a></div>
                </div>
            </div>
          </div>
        </div>
        <CoorayFooter background='bg-base-200 shrink-0' />
        {
                toastMessage && <div className="toast z-10">
                  <div className="alert alert-info">
                  <span className="text-sm">{toastMessage}</span>
                  </div>
              </div>
        }
      </div>
    )
  } else {
    return (
        <div className="bg-base-200 h-full flex flex-col">
        <div className="navbar px-4">
            <div className="flex-1">
                <img className="h-12" src="https://oesctluxvegwtcqckcdg.supabase.co/storage/v1/object/public/zipmap-resources/full-logo-lightning-light.png"/>
                <div className="text-xl font-bold px-2"></div>
            </div>
        </div>
              <div className='col-span-3 md:col-span-6 flex flex-col items-center justify-center pt-4'>
                  <div className="loading loading-infinity loading-lg"></div>
                  <div className='font-normal text-base-content mt-2'>Redirecting ...</div>
              </div>
        </div>
    )
  }
}